import { render } from "./MatchingRetrievalProcess.vue?vue&type=template&id=2d5020ac&scoped=true&ts=true&lang=pug"
import script from "./MatchingRetrievalProcess.vue?vue&type=script&lang=ts"
export * from "./MatchingRetrievalProcess.vue?vue&type=script&lang=ts"

import "./MatchingRetrievalProcess.vue?vue&type=style&index=0&id=2d5020ac&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5020ac"]])

export default __exports__